import type React from 'react';

import { noop } from 'lodash-es';
import type { TreeNode } from 'tree-model';

import { OBJECT_TYPE_COLLECTIONS } from '@iconik-io/iconik-api/src/types/object_types';

import type { TreeReducerModel } from '../../ducks/tree/types';
import { useAppSelector } from '../../store/react_redux_typed';
import { UUID_ZERO } from '../../utils/tree_handlers';
import selectMergedPermissions from '../permissions_manager/selectors';
import { TreeRow } from '../tree/tree_row';

type CollectionTreeRowProps = {
  node: TreeNode<TreeReducerModel>;
  selectedIds: string[];
  isSearchResults: boolean;
  onClick: (node: TreeNode<TreeReducerModel>) => void;
  onLoadMore: (
    node: TreeNode<TreeReducerModel>,
    event: React.MouseEvent,
  ) => void;
  onExpand: (node: TreeNode<TreeReducerModel>) => void;
  disableTopLevel?: boolean;
  shouldHaveBreadcrumbs?: boolean;
};

export function CollectionTreeRow({
  node,
  selectedIds,
  isSearchResults,
  onClick,
  onLoadMore,
  onExpand,
  disableTopLevel,
  shouldHaveBreadcrumbs,
}: CollectionTreeRowProps) {
  const collection = node.model;
  const permissions = useAppSelector((state) =>
    selectMergedPermissions(state, OBJECT_TYPE_COLLECTIONS, collection.id),
  );
  const isAdmin = useAppSelector((state) =>
    Boolean(state.authReducer.userData.is_admin),
  );
  const canWrite = permissions?.write || isAdmin;
  const rootIsDisabled = disableTopLevel && node.model.id === UUID_ZERO;

  return (
    <TreeRow
      node={node}
      withMenu={false}
      onLoadMore={onLoadMore}
      onExpand={onExpand}
      onClick={canWrite ? onClick : noop}
      selectedIds={selectedIds}
      isDisabled={!canWrite || rootIsDisabled}
      isSearchResults={isSearchResults}
      shouldHaveBreadcrumbs={shouldHaveBreadcrumbs}
    />
  );
}
